<span
  class="inline-flex items-center gap-1 whitespace-nowrap rounded-full px-2 py-0.5 text-xs font-semibold"
  [ngClass]="styles[priority].badge"
>
  <app-icon class="!h-3.5 !w-3.5 !text-[14px] !leading-none">{{ styles[priority].icon }}</app-icon>
  {{ 'crm_tasks.priority.' + priority | translate }}
</span>
